module.exports = __webpack_public_path__ + "static/media/only.6cb65560.meteorOrNode";